import { render, staticRenderFns } from "./DatesSelection.vue?vue&type=template&id=588aae1a&scoped=true"
import script from "./DatesSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatesSelection.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588aae1a",
  null
  
)

export default component.exports